<template>
	<div id="secondary-nav">
		<div class="inner-nav-container nav-site-container">
			<ul class="table-list site-nav-list">
				<li v-for="item in siteNavigation" :key="item.key" @click="openPageNav()">
					<i
						v-if="!breakpoint.isLarge"
						class="arrow-toggle"
						:class="showPageNav ? 'down-arrow' : 'right-arrow'"
					/>
					{{ breakpoint.isLarge ? item.key : item.subTitle }}
				</li>
			</ul>
		</div>
		<template v-if="showPageNav || breakpoint.isLarge">
			<div
				v-for="item in siteNavigation"
				:key="item.key"
				class="inner-nav-container nav-page-container"
			>
				<h3 v-if="!breakpoint.isLarge" class="nav-page-header">{{ item.key }}</h3>
				<ul class="table-list page-nav-list">
					<li
						v-for="page in item.navButtons"
						:key="page.title"
						:class="page.isActive ? 'active' : 'not-active'"
					>
						<a v-if="!page.isActive" :href="page.link" @click="() => navClick(page)">{{ page.title }}</a>
						<span v-else>{{ page.title }}</span>
					</li>
				</ul>
			</div>
		</template>
	</div>
</template>

<script>
export default {
	name: 'SecondaryNavigation',
	props: {
		siteNavigation: {
			type: Array,
			default() {
				return [
					{
						key: '',
						subTitle: '',
						navButtons: []
					}
				];
			}
		}
	},
	data() {
		return {
			showPageNav: false
		};
	},
	beforeMount() {
		this.$nextTick(() => {
			window.addEventListener('resize', () => {
				this.breakpoint.isSmall = window.innerWidth <= 480;
				this.breakpoint.isMedium =
					window.innerWidth > 480 && window.innerWidth < 770;
				this.breakpoint.isLarge = window.innerWidth > 769;
			});
		});
	},
	methods: {
		openPageNav() {
			if (!this.breakpoint.isLarge) {
				if (this.showPageNav === false) {
					this.showPageNav = true;
				} else {
					this.showPageNav = false;
				}
			}
		},
		navClick(link) {
			if (!link.isActive) this.$emit('nav-click', link);
		}
	}
};
</script>

<style lang="less">
@import '~_css_/variables';
#secondary-nav {
	.arrow-toggle {
		display: inline-block;
		width: 16px;
		height: 16px;
		background-repeat: no-repeat;
		background-position: top left;
		vertical-align: top;
		margin-top: 1px;
		&.down-arrow {
			background-image: url('../../assets/img/ARROW_DOWN_icon_white.png');
		}
		&.right-arrow {
			background-image: url('../../assets/img/ARROW_RIGHT_icon_white.png');
		}
	}
	.inner-nav-container {
		width: 100%;
		margin: auto;
		background-color: #fff;
		&.nav-site-container {
			background-color: #818181;
			background-image: linear-gradient(to top, #818181, #999);
		}
		&.nav-page-container {
			overflow: hidden;
			transition: height 400ms linear;
			background-color: #ffffff;
		}
	}
	.table-list {
		color: #000;
		font-family: 'AvenirNextLTW01-Regular', Arial, serif;
		list-style-type: none;
		margin: auto;
		padding: 6px;
		padding-bottom: 0px;
		&.site-nav-list {
			max-width: 996px;
			li {
				display: inline-block;
				line-height: 22px;
				padding: 12px;
				background-color: #fff;
				width: 33%;
				font-family: 'Avenir Next LT W01 Demi', Arial, sans-serif;
				font-size: 18px;
				color: grey;
			}
		}
		&.page-nav-list {
			padding-left: 13px;
			width: 996px;
			li {
				&.active {
					background-color: #cccccc;
				}
				&.not-active + .not-active {
					border-left: 1px solid #999;
				}
				display: inline-flex;
				cursor: pointer;
				width: fit-content;
				font-family: 'Avenir Next LT W01 Demi', Arial, sans-serif;
				font-size: 12px;
				a {
					padding: 9px;
				}
				span {
					cursor: default;
					text-decoration: none;
					padding: 6px;
				}
			}
		}
	}
	@media (max-width: 768px) {
		height: auto;
		padding: 0;
		background-color: transparent;
		background-image: none;
		.inner-nav-container {
			width: 100%;
		}
		.nav-page-header {
			border-top: 2px solid #666;
			color: #000;
			font-size: 16px;
			font-family: 'Avenir Next LT W01 Demi', Arial, sans-serif;
			margin: 26px 13px 15px 13px;
			padding-top: 13px;
		}
		.table-list {
			padding: 0;
			&.site-nav-list {
				li {
					display: inline-block;
					line-height: 18px;
					padding: 6px 13px;
					margin-bottom: 0;
					background-color: transparent;
					width: 100%;
					font-family: 'Avenir Next LT W01 Demi', Arial, sans-serif;
					font-size: 18px;
					color: #fff;
				}
			}
			&.page-nav-list {
				padding: 0px;
				width: 100%;
				li {
					cursor: pointer;
					font-family: 'Avenir Next LT W01 Demi', Arial, sans-serif;
					font-size: 12px;
					list-style: none;
					.thin-light-gray-border-bottom();
					padding: 6px 0;
					margin: 4px 13px 4px 28px;
					background-color: #fff;
					width: auto;
				}
			}
		}
	}
}
</style>
